import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Sidebar from './components/Sidebar';
import Login from './components/Login';
import MobileAppRedirect from './components/MobileAppRedirect';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';
import Drivers from './screens/Drivers';
import Users from './screens/Users';
import Loads from './screens/Loads';
import Bids from './screens/Bids';
import Dashboard from './screens/Dashboard';
import Locations from './screens/Locations';
import Addresses from './screens/Adresler';
import { FiMapPin } from 'react-icons/fi';
import Adresler from './screens/Adresler';
import MapIcon from '@mui/icons-material/Map';
import Companies from './screens/Companies';
import Customers from './screens/Customers';
import Customs from './screens/Customs';
import Countries from './screens/Countries';
import Agreements from './screens/Agreements';
import { FiPackage } from 'react-icons/fi';
import InstructionTemplates from './screens/InstructionTemplates';
import DogrulamaKodlari from './screens/DogrulamaKodlari';
import GizlilikPolitikasi from './components/GizlilikPolitikasi';
import OperasyonYetkilileri from './screens/OperasyonYetkilileri';
import DocumentRequirements from './screens/DocumentRequirements';
import Ayarlar from './screens/Ayarlar';
import BildirimSablonlari from './screens/BildirimSablonlari';
import GondericiAliciFirmalar from './screens/GondericiAliciFirmalar';
import Expenses from './screens/Expenses';
import UnifiedAddresses from './screens/UnifiedAddresses';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Show loading spinner while auth state is being checked
  if (loading) {
    return <div h="100vh"></div>;
  }

  // Redirect to login if no user
  if (!user) {
    return <Navigate to="/login" />;
  }

  // if (user.user_metadata?.role !== "admin") {
  //   return <Navigate to="/login" />;
  // }

  return children;
};

const LinkItems = [
  // ... existing links ...
  { name: 'Adresler', icon: FiMapPin, href: '/adresler' },
  { name: 'Gümrükler', icon: FiPackage, href: '/customs' },
  // ... existing links ...
];

function App() {
  return (
    <SnackbarProvider maxSnack={3}>
      <div className="App">
        <Router>
          <Routes>
            {/* Public routes that don't need auth - completely independent */}
            <Route path="/mobile-redirect" element={<MobileAppRedirect />} />
            <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
            
            {/* Routes that need auth context */}
            <Route
              path="/*"
              element={
                <AuthProvider>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/*"
                      element={
                        <ProtectedRoute>
                          <div className="flex">
                            <Sidebar></Sidebar>
                            <main className="flex-1 ml-64">
                              <Routes>
                                <Route path="/" element={<Dashboard />} />
                                <Route path="/drivers" element={<Drivers />} />
                                <Route path="/users" element={<Users />} />
                                <Route path="/loads" element={<Loads />} />
                                <Route path="/bids" element={<Bids />} />
                                <Route path="/expenses" element={<Expenses />} />
                                <Route path="/locations" element={<Locations />} />
                                <Route path="/adresler" element={<Adresler />} />
                                <Route path="/unified-addresses" element={<UnifiedAddresses />} />
                                <Route path="/companies" element={<Companies />} />
                                <Route path="/customers" element={<Customers />} />
                                <Route path="/customs" element={<Customs />} />
                                <Route path="/countries" element={<Countries />} />
                                <Route path="/agreements" element={<Agreements />} />
                                <Route
                                  path="/instruction-templates"
                                  element={<InstructionTemplates />}
                                />
                                <Route
                                  path="/dogrulama-kodlari"
                                  element={<DogrulamaKodlari />}
                                />
                                <Route
                                  path="/operasyon-yetkilileri"
                                  element={<OperasyonYetkilileri />}
                                />
                                <Route
                                  path="/document-requirements"
                                  element={<DocumentRequirements />}
                                />
                                <Route path="/ayarlar" element={<Ayarlar />} />
                                <Route
                                  path="/bildirim-sablonlari"
                                  element={<BildirimSablonlari />}
                                />
                                <Route
                                  path="/gonderici-alici-firmalar"
                                  element={<GondericiAliciFirmalar />}
                                />
                                {/* Add more routes as needed */}
                              </Routes>
                            </main>
                          </div>
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </AuthProvider>
              }
            />
          </Routes>
        </Router>
      </div>
    </SnackbarProvider>
  );
}

export default App;
